import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

export interface usePropostaVendasInterface {
  idUnidade: number;
  idLeadCorretor: number;
  fluxoNovo?: boolean;
}

export function usePropostaVendas(
  props: usePropostaVendasInterface & QueryGlobalInterface
) {
  const fetchData = async () => {
    const PROPOSTA_VENDAS = `${backofficeEnviroment}/common/oportunidades-lead/listar-simulacoes/v1/${props.idUnidade}/${props.idLeadCorretor}/${props.fluxoNovo}`;
    const response = await instance.get(PROPOSTA_VENDAS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    cacheTime: 0,
    onError: (error: any) => {
      toast?.error(
        `Erro ao buscar Proposta de vendas. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
